<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-card class="ma-3" max-width="900" outlined>
        <v-card-title>
          {{ $t("information.title") }}
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="tab">
            <v-tabs-slider color="orange"></v-tabs-slider>
            <v-tab>{{ $t("information.undergraduate") }}</v-tab>
            <v-tab>{{ $t("information.postgraduate") }}</v-tab>
          </v-tabs>
          <v-divider class="mt-3 mb-3" />
          <v-tabs-items v-model="tab">
            <!-- ระดับปริญญาตรี -->
            <v-tab-item>
              <p class="text">{{ $t("information.no_1") }}</p>
              <p class="text">
                {{ $t("information.no_2") }}
                <span class="red--text">
                  {{ $t("information.no_2cut1") }}
                </span>
              </p>
              <p class="text">
                {{ $t("information.no_3") }}
                <span class="red--text">
                  {{ $t("information.no_3cut1") }}
                </span>
              </p>
              <p class="text">{{ $t("information.no_4") }}</p>
              <p class="text">
                5.
                {{ $t("information.student") }}
                <b>
                  <u>{{ $t("information.no_5cut1") }}</u>
                </b>
              </p>
              <p class="text">
                6.
                <span class="red--text">{{ $t("information.no_6") }} </span>
              </p>
              <div class="ml-5">
                <p class="text">
                  {{ $t("information.no_6_1") }}
                  <b>
                    <u>{{ $t("information.no_6_1cut1") }}</u>
                  </b>
                  {{ $t("information.no_6_1cut2") }}
                </p>
              </div>
              <div class="ml-5">
                <p class="text">
                  {{ $t("information.no_6_2") }}
                  <b>
                    <u>{{ $t("information.no_6_2cut1") }}</u>
                  </b>
                  {{ $t("information.no_6_2cut2") }}
                </p>
              </div>
              <div class="ml-5">
                <p class="text">
                  {{ $t("information.no_6_3") }}
                  <b>
                    <u>{{ $t("information.no_6_3cut1") }}</u>
                  </b>
                  {{ $t("information.no_6_3cut2") }}
                </p>
              </div>
              <div class="ml-5">
                <p class="text">
                  {{ $t("information.no_6_4") }}
                  <b>
                    <u>{{ $t("information.no_6_4cut1") }}</u>
                  </b>
                  {{ $t("information.no_6_4cut2") }}
                </p>
              </div>
              <p class="text">
                7.
                <span class="red--text">{{ $t("information.no_7") }} </span>
              </p>
              <div class="ml-5">
                <p class="text">7.1 {{ $t("information.no_7_1") }}</p>
              </div>
              <div class="ml-5">
                <p class="text">7.2 {{ $t("information.no_7_2") }}</p>
              </div>
              <p class="text">
                8.
                <span class="red--text">{{ $t("maintain.title") }} </span>
              </p>
              <div class="ml-5">
                <p class="text">
                  {{ $t("maintain.basic_info") }}
                </p>
              </div>
            </v-tab-item>
            <!-- ระดับบัณฑิตศึกษา -->
            <v-tab-item>
              <p class="text-right font-italic">{{ $t("information.grad_no_0") }}</p>
              <p class="text mt-3">{{ $t("information.no_1") }}</p>
              <p class="text">
                {{ $t("information.no_2") }}
                <span class="red--text">
                  {{ $t("information.no_2cut1") }}
                </span>
              </p>
              <p class="text">
                3.
                <span class="red--text">{{ $t("information.no_6") }} </span>
              </p>
              <div class="ml-5">
                <p class="text">
                  {{ $t("information.student") }}
                  <b>
                    <u>{{ $t("information.no_5cut1") }}</u>
                  </b>
                </p>
              </div>
              <p class="text">
                4.
                <span class="red--text">{{ $t("information.no_7") }} </span>
              </p>
              <div class="ml-5">
                <p class="text">{{ $t("information.no_7_2") }}</p>
              </div>
              <p class="text">
                5.
                <span class="red--text">{{ $t("maintain.title") }} </span>
              </p>
              <div class="ml-5">
                <p class="text">
                  {{ $t("maintain.basic_info_x") }}
                </p>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <!-- <v-card-actions class="justify-center">
        <v-btn
          elevation="5"
          class="ma-5 primary"
          :to="{ path: 'home' }"
          >{{ $t("information.accept") }}</v-btn
        >
      </v-card-actions> -->
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PreRegisConfirmConsent",
  props: {
    clickNext: {
      type: Function,
    },
  },
  data: () => ({
    tab: null,
  }),
};
</script>

<style>
.text {
  font-size: 1.3em;
  line-height: 1.5em;
}
</style>
